import React from 'react';

import { Button } from 'shadcn/components/ui/Button';
import { Label } from 'shadcn/components/ui/Label';
import { cn } from 'shadcn/lib/utils';

import { INGEST_RESULT_TYPE_FILTER_OPTIONS } from './ingestResultTypeFilterConfig';

/**
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string[]} props.selectedTypes - Active ingest result type filters
 * @param {(types: string[]) => void} props.onSelectedTypesChange
 */
function IngestResultTypeFilter({ className, onSelectedTypesChange, selectedTypes }) {
    const handleToggle = (value) => {
        if (selectedTypes.includes(value)) {
            onSelectedTypesChange(selectedTypes.filter((t) => t !== value));
            return;
        }
        onSelectedTypesChange([...selectedTypes, value]);
    };

    const handleClear = () => {
        onSelectedTypesChange([]);
    };

    return (
        <div className={cn('flex flex-col items-end space-y-1.5', className)}>
            <div className="flex items-center justify-end gap-2">
                <Label className="text-sm">Filter by type</Label>
                {selectedTypes.length > 0 ? (
                    <Button type="button" variant="ghost" size="sm" className="h-7 px-2 text-xs" onClick={handleClear}>
                        Clear
                    </Button>
                ) : null}
            </div>
            <div className="flex flex-wrap justify-end gap-2">
                {INGEST_RESULT_TYPE_FILTER_OPTIONS.map(({ label, value }) => {
                    const isSelected = selectedTypes.includes(value);
                    return (
                        <Button
                            key={value}
                            type="button"
                            variant={isSelected ? 'default' : 'outline'}
                            size="sm"
                            className={cn('h-8 rounded-full px-3', !isSelected && 'text-muted-foreground')}
                            aria-pressed={isSelected}
                            onClick={() => handleToggle(value)}
                        >
                            {label}
                        </Button>
                    );
                })}
            </div>
        </div>
    );
}

export { IngestResultTypeFilter };
